module.exports = __webpack_public_path__ + "01_cheeks.7e6bd813.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer3/01_cheeks.png
// module id = XnY5
// module chunks = 0